import React from 'react';
import { useTranslation } from 'react-i18next';

function InfoCard({ iconSrc, label, date, count, validCount }) {
  const { t } = useTranslation();
  const displayCount = validCount !== undefined ? validCount : count;

  return (
    <div className="info-card">
      <div className="info-row">
        <div className="info-label">
          <span className="icon">
            <img src={iconSrc} alt={label} width="20" height="20" />
          </span>
          {label}
        </div>
        <div className="info-value">
          <span className="date">{date}</span>
          <span className="count">
            {displayCount}<span className="unit">{t('infoCard.times')}</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default InfoCard;
